import { byMethod } from '@oysterjs/core/graphql/actions';
import { merge } from '@oysterjs/core/graphql/loaders';
import type { RouteObject } from 'react-router-dom';
import {
  submitCreateAgencyProducerInformation,
  submitUpdateAgency,
  submitUpdateProducerInformation
} from '~/api/data/agencies/mutations';
import {
  loadAgencyProducerInformations,
  loadDefaultACORDFormConfiguration
} from '~/api/data/agencies/queries';
import { loadCurrentUser } from '~/api/data/users/queries';
import { Action, Resource } from '~/api/graphql';
import { ProtectedRoute } from '~/components/permissions';
import {
  ProducerInformationCreatePage,
  ProducerInformationEditPage,
  SettingsAgencyPage
} from '~/pages/settings/agency';

export const agencyRoute: RouteObject = {
  path: 'agency',
  loader: merge({
    agencyUser: loadCurrentUser,
    producerInformations: loadAgencyProducerInformations,
    defaultAcordFormConfiguration: loadDefaultACORDFormConfiguration
  }),
  action: byMethod({
    PUT: submitUpdateAgency
  }),
  element: (
    <ProtectedRoute
      permissions={[{ resource: Resource.Agency, action: Action.Update }]}
      redirectTo="/app/settings/subscription"
    >
      <SettingsAgencyPage />
    </ProtectedRoute>
  ),
  children: [
    {
      path: 'producer-information/new',
      action: byMethod({
        POST: submitCreateAgencyProducerInformation
      }),
      element: <ProducerInformationCreatePage />
    },
    {
      path: 'producer-information/:id/edit',
      loader: merge({
        producerInformations: loadAgencyProducerInformations
      }),
      action: byMethod({
        PUT: submitUpdateProducerInformation
      }),
      element: <ProducerInformationEditPage />
    }
  ]
};
